import { motion } from "framer-motion";

// Fade-and-rise on scroll. ≤300ms, ease-out, no bounce — per brand spec.
export const Reveal = ({ children, delay = 0, className = "", y = 16 }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.5, delay, ease: [0.22, 1, 0.36, 1] }}
    >
        {children}
    </motion.div>
);

export default Reveal;
